/**
 * @public
 */
export enum NodeType {
	ELEMENT_NODE = 1,
	TEXT_NODE = 3,
	DOCUMENT_NODE = 9,
}
